import * as React from "react"
import { Moment } from 'moment';
import { RentalAdvertPricing, RentalAdvert } from '../../types/types'
import { StartEnd } from '../../utils/period_picker/PeriodPicker'
import { FocusedInputShape } from 'react-dates';
import Pricing from "./components/RebookingForm/Pricing";
import Inputs from "./components/RebookingForm/Inputs";
import SubmitButton from "./components/RebookingForm/SubmitButton";

type Props = {
  advert: RentalAdvert
  arrival_date: Moment
  departure_date: Moment
  max_people_select: number
  max_people: number
  pricing: RentalAdvertPricing
  focusedInput: FocusedInputShape
  onDatesChange: (_: StartEnd) => void
  onFocusedInputChange: (_:FocusedInputShape) => void
  onMaxPersonsChange: (_:number) => void
  onSubmit: () => void
  button_disabled: boolean
  room_id: number
}

export default (props: Props) => (
  <div className='box--conversation'>
    <div className='box box--yellow sidebar-inner'>
        <div className='box__body box__body--price'>
          <div className='price'>
            {
              props.pricing ?
                <Pricing
                  pricing={props.pricing}
                />
              : ''
            }
          </div>
        </div>
        <div className='box__body box__body--bt box__body--form'>
          <div className='form-row'>
              <div className='form-row tac'>{I18n.t('conversations.period')}</div>
          </div>
          {
            props.advert ?
              <Inputs
                focusedInput={props.focusedInput}
                onDatesChange={(range) => props.onDatesChange(range)}
                onFocusedInputChange={(fi) =>  props.onFocusedInputChange(fi)}
                onMaxPersonsChange={(e) => props.onMaxPersonsChange(e)}
                arrival_date={props.arrival_date}
                departure_date={props.departure_date}
                advert={props.advert}
                max_people={props.max_people}
                max_people_select={props.max_people_select}
                room_id={props.room_id}
              />
            : ''
          }
        </div>
        {
          props.pricing && props.pricing.error && props.arrival_date && props.departure_date ?
            <div className="box__body unavailable" dangerouslySetInnerHTML={{__html: props.pricing.error}} />
            :
            ''
        }
        <div className='box__body box__body--button'>
          <div className='form-row'>
            <div className='form-cell'>
              {
                props.pricing ?
                  <SubmitButton
                    pricing={props.pricing}
                    onSubmit={() => props.onSubmit()}
                    disabled={props.button_disabled}
                  />
                : null
              }
            </div>
          </div>
        </div>
    </div>
  </div>
)


